export default __webpack_public_path__ + "static/media/flag-east-timor.bee173ca.svg";